import React from 'react'
import ChartJS, {
  IChartJSProps
} from '../../../../../components/common/charts/ChartJS'

interface IUserInsightsBoxBarChartProps extends IChartJSProps {
  config: Chart.ChartConfiguration
  data: any[]
  colorPalette?: any[]
}

function buildChartJSData(
  data: Array<{ title: string; count: number }>,
  colorPalette
) {
  const dataset = {
    data: [...data.map((item) => item.count)],
    backgroundColor: colorPalette
      ? colorPalette.map((color) => `#${color}`)
      : '#E2E8EA'
  }
  const labels = [...data.map((item) => item.title)]

  return {
    labels,
    datasets: [dataset],
    noData: !data.length
  }
}

export const UserInsightsBoxBarChart = ({
  data,
  colorPalette,
  config,
  ...props
}: IUserInsightsBoxBarChartProps) => {
  config.data = buildChartJSData(data, colorPalette)
  return <ChartJS {...props} config={config} />
}
